import { render } from "./MessageBox.vue?vue&type=template&id=28cdad88&scoped=true&ts=true"
import script from "./MessageBox.vue?vue&type=script&lang=ts"
export * from "./MessageBox.vue?vue&type=script&lang=ts"

import "./MessageBox.vue?vue&type=style&index=0&id=28cdad88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cdad88"]])

export default __exports__